<template>
    <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
    >
        <v-card>
            <v-card-title>
                <v-subheader>{{ $t('departments.teamMember.form.data') }}</v-subheader>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-progress-linear :indeterminate="true" v-show="form.loading"></v-progress-linear>

            <v-card-text v-show="!form.loading">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="user.name"
                                :rules="form.rules.name"
                                :label="$t('departments.teamMember.form.name.label')"
                                required
                                filled
                                :readonly="form.isEdit && !checkIsOwner()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"  md="6">
                            <v-text-field
                                v-model="user.username"
                                :rules="form.rules.username"
                                :label="$t('departments.teamMember.form.username.label')"
                                required
                                filled
                                :readonly="form.isEdit"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="userCompany.profile.jobTitle"
                                :rules="form.rules.jobTitle"
                                :label="$t('departments.teamMember.form.jobTitle.label')"
                                required
                                filled
                                :readonly="form.isEdit && !checkIsOwner()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="form.fieldMasks.phone"
                                :rules="form.rules.phone"
                                :label="$t('departments.teamMember.form.phone.label')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                required
                                filled
                                :readonly="form.isEdit && !checkIsOwner()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" md="2">
                            <div class="d-flex align-center justify-end input-height">
                                <span class="mr-1">{{ $t('departments.teamMember.form.pickColor') }}</span>
                                <swatches
                                    v-model="userCompany.profile.color"
                                    popover-to="left"
                                    show-fallback
                                    fallback-input-type="color"
                                    :readonly="form.isEdit && !checkIsOwner()"
                                ></swatches>
                            </div>
                        </v-col>
                        <v-col cols="4" md="2">
                            <div class="d-flex align-center justify-end input-height">
                                <v-switch
                                    flat
                                    inset
                                    v-model="userCompany.permissions.isMainAccount"
                                    :label="$t('departments.teamMember.form.mainAccount.label')"
                                ></v-switch>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>
        </v-card>
    </v-form>
</template>

<script>
import API from '@/api'
import Swatches from 'vue-swatches'
import { mask } from 'vue-the-mask'

export default {
    name: 'form-user',
    metaInfo () {
        return {
            title: this.$t('departments.teamMember.form.meta.title'),
            meta: [
                { name: 'description', content: this.$t('departments.teamMember.form.meta.description') },
                { name: 'keywords', content: this.$t('departments.teamMember.form.meta.keywords') }
            ]
        }
    },
    components: {
        Swatches
    },
    directives: {
        mask
    },
    data: function () {
        return {
            isEmployee: false,
            form: {
                isEdit: false,
                valid: false,
                rules: {
                    name: [
                        v => !!v || this.$t('departments.teamMember.form.name.required'),
                        v => (v && v.length >= 3) || this.$t('departments.teamMember.form.name.length')
                    ],
                    jobTitle: [
                        v => !!v || this.$t('departments.teamMember.form.jobTitle.required'),
                        v => (v && v.length >= 3) || this.$t('departments.teamMember.form.jobTitle.length')
                    ],
                    username: [
                        v => !!v || this.$t('departments.teamMember.form.username.required'),
                        v => /.+@.+/.test(v) || this.$t('departments.teamMember.form.username.test')
                    ],
                    phone: [
                        v => !!v || this.$t('departments.teamMember.form.phone.required'),
                        v => (v && v.length >= 8) || this.$t('departments.teamMember.form.phone.length')
                    ]
                },
                loading: true,
                fieldMasks: {
                    phone: undefined
                }
            },
            user: {
                objectId: undefined,
                name: undefined,
                username: undefined
            },
            userCompany: {
                user: undefined,
                client: undefined,
                profile: {
                    color: '#2980b9',
                    phone: undefined,
                    jobTitle: undefined
                },
                nameLowerCase: undefined,
                permissions: {
                    isMainAccount: false
                }
            }
        }
    },
    mounted () {
        if (this.$route.params.id != null) {
            this.loadData()
        } else {
            this.form.loading = false
        }
        if (this.$route.params.requesterType !== undefined && this.$route.params.requesterType !== null) {
            this.isEmployee = true
        }
    },
    computed: {
        formMethod () {
            return (this.$route.params.id != null)
        }
    },
    methods: {
        getClientObjectId () {
            if (this.$route.params.requesterType !== undefined && this.$route.params.requesterType !== null) {
                return this.$route.params.requesterType
            } else {
                return this.$helpers.getUserCompany().client.objectId
            }
        },
        checkIsOwner () {
            const profile = JSON.parse(localStorage.profile)
            return (this.$route.params.id === profile.objectId)
        },
        loadData () {
            const endpoint = API.EndPoints.getUserCompanyDetail
            endpoint.id = this.$route.params.id
            const params = {
                include: ['user']
            }
            return new API(endpoint, params).request().then(response => {
                const data = response.body
                this.userCompany = { ...data }
                this.user = {
                    objectId: data.user.objectId,
                    name: data.user.name,
                    username: data.user.username
                }
                this.form.fieldMasks.phone = this.userCompany.profile?.phone
                this.form.isEdit = true
                this.form.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async save (isEditing) {
            if (this.$refs.form.validate()) {
                this.form.valid = false
                if (isEditing) {
                    await this.saveUser(isEditing)
                    const userCompanySaved = await this.saveUserCompany(this.user, isEditing)
                    if (!userCompanySaved.hasOwnProperty('updatedAt')) {
                        alert(this.$t('departments.teamMember.form.errorUpdateAdmin'))
                        return
                    }
                    this.saveSuccess(isEditing, this.user)
                } else {
                    let userSaved = await this.saveUser(isEditing)
                    if (userSaved.hasOwnProperty('code') && userSaved.code === 202) {
                        userSaved = await this.getUserByEmail()
                    }
                    if (userSaved.hasOwnProperty('objectId')) {
                        const userCompanySaved = await this.saveUserCompany(userSaved, isEditing)
                        if (!userCompanySaved.hasOwnProperty('objectId')) {
                            alert(this.$t('departments.teamMember.form.errorRelation'))
                            return
                        }
                    } else {
                        alert(this.$t('departments.teamMember.form.errorCreate'))
                        return
                    }
                    this.saveSuccess(isEditing, userSaved)
                }
            }
        },
        async saveUser (isEditing) {
            this.user.type = 'department'
            this.user.client = { __type: 'Pointer', className: 'Client', objectId: this.getClientObjectId() }

            let endpoint = API.EndPoints.addUser
            if (isEditing) {
                endpoint = API.EndPoints.editUser
                endpoint.id = this.user.objectId
            } else {
                this.user.password = Math.random().toString(36).slice(-10)
            }
            return this.callApi(endpoint, JSON.stringify(this.user))
        },
        async saveUserCompany (user, isEditing) {
            const userCompany = this.$helpers.getUserCompany()

            this.userCompany.type = 'department'
            this.userCompany.user = { __type: 'Pointer', className: '_User', objectId: user.objectId }
            this.userCompany.client = { __type: 'Pointer', className: 'Client', objectId: this.getClientObjectId() }

            this.userCompany.parent = { __type: 'Pointer', className: 'Client', objectId: userCompany?.parent?.objectId ?? userCompany?.client?.objectId }

            this.userCompany.profile.phone = this.$helpers.unmask(this.form.fieldMasks.phone)
            this.userCompany.nameLowerCase = this.user.name.toLowerCase()

            let endpoint = API.EndPoints.addUserCompany
            if (isEditing) {
                endpoint = API.EndPoints.editUserCompany
                endpoint.id = this.userCompany.objectId
            }
            return this.callApi(endpoint, JSON.stringify(this.userCompany))
        },
        callApi (endpoint, params) {
            return new API(endpoint, params).request()
                .then((response) => {
                    return response.body
                }, (e) => {
                    return e.body
                })
        },
        getUserByEmail () {
            let endpoint = API.EndPoints.getUsers
            const params = {
                where: JSON.stringify({
                    username: this.user.username
                })
            }
            return new API(endpoint, params).request().then(response => {
                return Object.assign({}, response.body.results[0])
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        saveSuccess (boolean, user) {
            if (this.isEmployee) {
                this.$router.go(-1)
            } else {
                this.$router.push('/colaboradores').catch(e => {})
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
  .input-height
    height 57px
    position relative
</style>
